// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pdfTemple[data-v-2c68b246] {\n  font-size: 12px;\n  padding: 20px;\n}\n.pdfTemple .title[data-v-2c68b246] {\n  font-size: 18px;\n  color: #8f8f8f;\n  font-weight: bold;\n}\n.pdfTemple .form-item[data-v-2c68b246] {\n  margin-bottom: 5px;\n}\n.pdfTemple .form-label[data-v-2c68b246] {\n  font-weight: bold;\n  width: 200px;\n}\n[data-v-2c68b246] .emptyItem th.el-table__cell > .cell {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
